import React, { forwardRef } from "react";
import cn from "classnames";
import { useTranslation } from "shared/localization/localization";
import styles from "./Button.module.scss";

type ButtonProps = {
  count: number;
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>>(
  ({ count, ...props }, ref) => {
    const { t } = useTranslation();
    if (count > 0) {
      return (
        <button ref={ref} {...props} className={cn(styles.button, styles.hidden_on_mobile)}>
          <span>{t("Edit tag")}</span>
          <span className={styles.count}>{count}</span>
        </button>
      );
    } else {
      return (
        <button ref={ref} {...props} className={cn(styles.button, styles.hidden_on_mobile)}>
          <span>{t("Add first tag")}</span>
        </button>
      );
    }
  }
);

Button.displayName = "Button";
